import types from './types';
import { SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS } from '../inventories/types';
import { SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS } from '../chemicalProducts/types';

const defaultState = {
  casNumberList: [],
  isLoading: false
};

const updateCasNumberList = (state, params) => {
  let { casNumberList } = state;
  let chemicalProduct = params.inventory
    ? params.inventory.chemicalProduct
    : params.chemicalProduct;
  if (
    chemicalProduct != null &&
    chemicalProduct.casNumber &&
    chemicalProduct.casNumber.id &&
    !casNumberList.some(c => c.id === chemicalProduct.casNumber.id)
  ) {
    casNumberList.push(chemicalProduct.casNumber);
  }
  return casNumberList;
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_CAS_NUMBER_LIST:
      return { ...state, isLoading: true };
    case types.GET_CAS_NUMBER_LIST_SUCCESS:
      return { ...state, casNumberList: data, isLoading: false };
    case types.GET_CAS_NUMBER_LIST_FAILURE:
      return { ...state, isLoading: false };

    case SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
    case SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      if (data.openConfirmationModal) return { ...state };
      else {
        let { casNumberList } = state;
        casNumberList = updateCasNumberList(state, data);
        return {
          ...state,
          casNumberList: casNumberList
        };
      }

    default:
      return state;
  }
};
